import { get } from '../utils/networking';

export type HrHome = {
  pulse: {
    open: Array<{
      id: number;
      title: string;
      team: string;
      responses: number;
      expected: number;
      deadline: string;
      /** Fewer have answered than the survey needs */
      lowResponse: boolean;
    }>;
    nextRound: string | null;
  };
  psychologicalSafety: {
    open: Array<{ id: number; team: string; deadline: string }>;
  };
};

export const getHrHome = () => get<HrHome>('/api/hr/home');
